const NAVIGATION_CONTROL_KEYS = new Set(["client", "target", "back", "redirect"]);

export function buildMobileLoginUrl(currentUrl: string, currentFullPath: string): string {
  const loginUrl = new URL("/official/login", currentUrl);

  loginUrl.search = "";
  new URL(currentUrl).searchParams.forEach((value, key) => {
    if (!NAVIGATION_CONTROL_KEYS.has(key)) {
      loginUrl.searchParams.append(key, value);
    }
  });

  loginUrl.searchParams.set("client", "mobile");
  loginUrl.searchParams.set("target", currentFullPath);
  loginUrl.searchParams.set("route_from", "pino-front");
  loginUrl.searchParams.set("device_env", "h5");

  return loginUrl.toString();
}
